import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { setCurrencyFormat } from 'src/utils/util';
import { RED_FONT_COLOR, X_SMALL_TEXT_PX, FONT_FAMILY_REGULAR } from 'src/styles/fonts/MCFontConstants';

export const WarningText = styled.div`
    font-size: 13px;
    color: #b56409;
    font-family: 'AvenirNextWorld Demi';
    line-height: 22.59px;
    font-weight: 600;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    ${media.mobileDevice`
        font-size: 12px;
   
        `}
`;

export const NoMatchError=styled.div`
    color:${RED_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    opacity: 0.7;
    font-size: ${X_SMALL_TEXT_PX};
    margin-top: 2px;
`;

export const ListContainerRightItems = styled.div`
    ${media.mobileDevice`
         display: flex;
        //  align-items: flex-end;
        `}
`;

export const WarningTextContainer = styled.span`
    color: #b56409;
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    display: flex;
`;

export const ItemsCardContainer = styled.div`
    display: flex;

    background: ${(props) =>
        props.background
            ? props.background
            : '#ffffff 0% 0% no-repeat padding-box'};
    border-radius: 6px;
    margin: ${({ marginOnLargeDevice, marginOnLargeDeviceSets }) =>
        marginOnLargeDevice ? marginOnLargeDevice : marginOnLargeDeviceSets ? '10px 2px 0 0' : '10px 5px 5px 5px'};
    border: ${({ fullBorder }) => (fullBorder ? fullBorder : '')};
    border-left: ${(props) =>
        props?.border?.border ? props?.border?.border : ''};
    min-width: ${(props, minWidthSets) =>
        props.minWidth.minWidth ? props.minWidth.minWidth : minWidthSets ? '99%' : '100%'};
    width: ${({ width }) => width};
    min-height: ${({ minHeight }) => (minHeight ? minHeight : '')};
    background-color: ${(props) => props.backgroundColor};
    ${media.mediumDevice`
    margin: ${({ marginOnMediumDevice, marginOnMediumDeviceSets }) =>
        marginOnMediumDevice ? marginOnMediumDevice : marginOnMediumDeviceSets ? '10px 0 0 2px' : '10px 5px 5px 5px'};
        min-width: ${({ tabDeviceWidth }) =>
            tabDeviceWidth ? tabDeviceWidth : ''};
    `}
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        min-width: ${({ tabDeviceLandscapeWidth }) =>
            tabDeviceLandscapeWidth ? tabDeviceLandscapeWidth : ''};
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        width: ${({ tabWidthPotrait }) => tabWidthPotrait};
    }

    ${media.mobileDevice`
        min-width: ${({ itemCardsContainerMinMobWidth , itemCardsContainerMinMobWidthSets }) => (itemCardsContainerMinMobWidth ? itemCardsContainerMinMobWidth : itemCardsContainerMinMobWidthSets ? '95%' : '100%')}; 
        margin:${({ margin, marginSets }) => (margin ? margin : marginSets ? '0 3px' : '10px 0px')};
        min-width: ${({ minMobileWidth }) =>
            minMobileWidth ? minMobileWidth : '100%'};
        margin: ${({ marginOnMobileDevice, marginOnMobileDeviceSets }) =>
            marginOnMobileDevice ? marginOnMobileDevice : marginOnMobileDeviceSets ? '0' : '0px auto 0px auto'};
        width: ${({ widthItem }) => (widthItem ? widthItem : '100%')};
        clip-path:${({ clipPath }) => clipPath};
    `}
`;

export const CheckBoxContainer = styled.div`
    padding-top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${media.mobileDevice`     
     
    margin-right: ${({ mbMargin }) => (mbMargin ? mbMargin : '0px')};
    
    `}
`;

export const RowContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'column'};
    justify-content: flex-start;
    position: relative; /* Always set position to relative so pseudo-elements work */
    padding: ${(props) =>
        props.contentPadding ? props.contentPadding : '15px'};
    width: ${(props) => (props?.width ? props?.width : '100%')};
    align-items: ${(props) => (props.alignItems ? props.alignItems : '')};
    margin-top: ${(props) => (props?.marginTop ? props?.marginTop : '')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '')};
    border-bottom: ${(props) =>
        props?.border && !props.isBundlesChildren ? props?.border : ''};

    @media (max-width: 500px) {
        padding: ${(props) => props.mbPadding && props.mbPadding};
    }

    /* Fix for the pseudo-element to display properly */
    ${(props) =>
        props.border &&
        props.isBundlesChildren && !props.isLastItem && 
        `
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 15px;
      right: 15px;
      height: 1px;
      background-color: lightgray;
      display: block;
   } 
    `}
`;

export const ColumnContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'space-between'};
    background-color: ${({ backgroundColor }) => backgroundColor};
    align-items: ${({ alignItems }) => alignItems};
    /* &.setName {
        color: #1010eb;
        font-family: 'AvenirNextWorld Demi';
        font-size: 16px;
    } */

    &.setCount {
        color: #000000;
        font-family: 'AvenirNextWorld Regular';
        font-size: 14px;
    }

    &.type {
        background: #ebebeb 0% 0% no-repeat padding-box;
        border-radius: 10px;
        display: inline;
        padding-left: 5px;
        padding-right: 5px;
        margin-left: 5px;
    }
    .dropBundle {
        justify-content: flex-start;
    }
    ${media.mobileDevice`     
     
        width: ${({ width }) => (width ? width : '98%')};; margin: 0 auto;
    
    `}
`;

export const FeesAndItemsValues = styled.div`
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    color: #140f4b;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    font-size: ${({ setOrItemDetailsFontSizeDesktop }) =>
        setOrItemDetailsFontSizeDesktop
            ? setOrItemDetailsFontSizeDesktop
            : '14px'};

    opacity: ${({ opacity }) => (opacity ? opacity : '1')};
    word-break: break-word;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    // 10-20mm coming on same line
    width: ${({ width }) => (width ? width : '100px')};
    // min-width: ${({ minWidth }) => (minWidth ? minWidth : '280px')};

    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    overflow: hidden;
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '0px'};
    ${media.mobileDevice`     
        font-size: ${({ setOrItemDetailsFontSizeMobile }) =>
            setOrItemDetailsFontSizeMobile
                ? setOrItemDetailsFontSizeMobile
                : '13px'};
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '')};
        margin-right: ${({ mbMarginRight }) =>
            mbMarginRight ? mbMarginRight : ''};
        margin-left:  ${({ mbMarginLeft }) =>
            mbMarginLeft ? mbMarginLeft : '0px'};   
    `}
`;

export const SetName = styled.div`
    display: ${(isconsignmentAddOrder) =>
        isconsignmentAddOrder ? isconsignmentAddOrder : 'flex'};
    color: ${(props) => (props.isQuickOrder ? '#130e4a' : props.color ? props.color : '#130e4a')};
    font-family: 'AvenirNextWorld Demi';
    font-size: ${(props) =>
        props.fontSizeDesktop ? props.fontSizeDesktop : '18px'};
    cursor: ${(props) => ((props.clickable && !props.isQuickOrder) ? 'pointer' : '')};
    ${media.mobileDevice`     
        font-size: ${(props) =>
            props.fontSizeMobile ? props.fontSizeMobile : '18px'};
    `}
    letter-spacing: ${(props) =>
        props.setNameLetterSpacing ? props.setNameLetterSpacing : 'normal'};
    line-height: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '20px' : 'unset'};
    white-space: ${(props) =>
        props.enableTemplateCardSpecificStyling ? ' break-spaces' : 'unset'};
`;

export const SetCount = styled.div`
    color: #000000;
    font-family: 'AvenirNextWorld Regular';
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '44px')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
    white-space: ${({ whiteSpace }) => whiteSpace && whiteSpace};

    @media (max-width: 500px) {
        margin-right: ${({ mbMarginRight }) =>
            mbMarginRight ? mbMarginRight : '0px'};
        margin-left: ${({ marginLeft }) =>
            marginLeft ? marginLeft : '0px'};
    }
`;

export const Type = styled.div`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: inline;
    padding-left: 6px;
    padding-right: 6px;
    margin-left: 5px;
    color: #140f4b;
    font-size: ${({ typeFontSize }) => (typeFontSize ? typeFontSize : '13px')};
    text-align: center;
    white-space: nowrap;
`;
export const ActionButton = styled.div`
    display: flex;
    justify-content: space-around;
    ${'' /* align-items: center; */}
    ${'' /* padding-left: 80px; */}
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '80px')};
    align-items: ${({ enableTemplateCardSpecificStyling, center }) =>
        center
            ? 'center'
            : enableTemplateCardSpecificStyling
            ? 'flex-start'
            : 'center'};
     ${media.mobileDevice`
        margin-right: ${({ isBundlesChildren, marginRight }) =>
            isBundlesChildren ? '13px' : marginRight ? marginRight : '0px'};
        margin-left: ${({ isEquityTemplateBundlePopup }) => isEquityTemplateBundlePopup ? '-15px' : ''}; `}
`;
export const Status = styled.div`
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '10px')};
    height: 21px;
    width: auto;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '15px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    align-items: center;
    text-align: center;
    ${media.mobileDevice`
        border-radius: 10px;
        margin-left: ${({ mbMarginLeft }) =>
            mbMarginLeft ? mbMarginLeft : '9px'};
    `}
`;
export const StatusText = styled.div`
    font-family: 'AvenirNextWorld Regular';
    padding-left: 5px;
    padding-right: 5px;
    height: 21px;
    width: auto;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: -0.1px;
    color: #140f4b;
    text-align: center;
    ${media.mobileDevice`     
    width: 100%;
    `}
`;
export const CardFooter = styled.div`
    display: ${({ display }) => (display ? display : 'flex')};
    margin: ${({ cartFooterMargin }) =>
        cartFooterMargin ? cartFooterMargin : '5px 0px 0px 0px'};
    justify-content: ${({ justifyContentWithoutBrand }) =>
        justifyContentWithoutBrand ? 'flex-start' : 'space-between'};
    align-items: center;
    align-items: ${(props) =>
        props.enableTemplateCardSpecificStyling ? 'left' : 'center'};

    ${media.mobileDevice`     
        margin:${(props, mbMargin) =>
            props.enableTemplateCardSpecificStyling
                ? '10px 0px 5px 0px'
                : mbMargin
                ? mbMargin
                : '5px 0px 5px 0px'};  
 
     `}
    position:${(props) =>
        props.enableTemplateCardSpecificStyling ? 'absolute' : ''};
    bottom: ${(props) => (props.enableTemplateCardSpecificStyling ? '0' : '')};
    width: ${(props) => (props.cardFooterWidth ? props.cardFooterWidth : '')};
`;
export const Brands = styled.div`
    display: flex;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    text-align: left;
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.11px'};
    color: ${({ color }) => (color ? color : '#000000')};
    font-size: 13px;
    word-break: ${({ wordBreak }) => wordBreak};
    ${media.mobileDevice`     
     
     `};
`;
export const BrandsName = styled.div`
    display: flex;
    text-align: left;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.11px'};
    font-size: 13px;
    color: ${({ color }) => (color ? color : '#000000')};
    margin: 0 2px 0 5px;

    ${media.mobileDevice`     
     
     `}
`;
export const Counter = styled.input.attrs(() => ({
    enterKeyHint: 'go',
}))`
    font-family: 'AvenirNextWorld Regular';
    border: ${({ border }) => (border ? border : '2px solid #ececec')};
    font-size: 13px;
    text-align: center;
    margin: auto 9px;
    border-radius: 4px;
    color: #000000;
    opacity: 1;
    height: ${({ height }) => (height ? height : '35px')};
    width: ${({ width }) => (width ? width : '50px')};
    background-color: ${({ mbBackGroundColor }) =>
            mbBackGroundColor ? mbBackGroundColor : 'transparent'};
`;
// export const Counter = styled.input.attrs((props) => {
//     type: 'text';
// })`
//     font-family: 'AvenirNextWorld Demi';
//     border: 2px solid #ececec;
//     font-size: 13px;
//     text-align: center;
//     margin: auto 9px;
//     border-radius: 4px;
//     color: #000000;
//     opacity: 1;
//     height: 35px;
//     width: 50px;
//     ${media.mobileDevice`

//      `}
// `;
export const AddedText = styled.div`
    color: #14853d;
    font-family: 'AvenirNextWorld Regular';
    font-size: 11px;
    margin-right: 10px;
`;
//product templates
export const UserAndFavoritesContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const UserNameAndDateContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 157px;
    /* ${media.mobileDevice`
       margin-right: 170px;
    `}; */
    & .userName {
        letter-spacing: 0;
        text-align: left;
        font-family: 'AvenirNextWorld Demi';
        letter-spacing: 0px;
        color: #140f4b;
        opacity: 1;
        font-size: 14px;
        padding-left: 7px;
        white-space: pre;
    }

    & .dateStamp {
        text-align: left;
        font-family: 'AvenirNextWorld Regular';
        letter-spacing: -0.1px;
        color: #000000;
        opacity: 0.6;
        font-size: 12px;
        margin-top: -5px;
        padding-left: 7px;
    }
`;

export const FavoriteIconContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: ${(props) =>
        props.enableTemplateCardSpecificStyling ? 'absolute' : ''};
    right: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '15px' : ''};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    width: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    max-width: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    min-width: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    height: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    bottom: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '4px' : 'unset'};
`;

export const Icon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 22px;
    height: 23px;
    cursor: ${(props) => (props.hideCursor ? 'unset' : 'pointer')};
    ${media.mobileDevice`
   
    `}
`;

export const ProductTemplateTitle = styled.div`
    color: #1010eb;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
`;

export const ProductTemplateDetailsHeader = styled.div`
    letter-spacing: 0;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: 0px;
    color: #140f4b;
    opacity: 1;
    font-size: 14px;
    //align text left
    //padding-left: 7px;
    white-space: pre;
    margin-top: 20px;
`;
export const NoShipText = styled.label`
    font-size: 12px;
    color: #f6610b;
    font-family: 'AvenirNextWorld Demi';
    margin: ${({ margin }) => margin};
`;
export const SetLocatedText = styled.label`
    font-size: 14px;
    color: #202124;
    font-family: 'AvenirNextWorld Demi';
    margin-top: 5px;
`;
export const SetLocatedRowDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${({ alignItem }) => (alignItem ? alignItem : 'flex-start')};
    margin-bottom: 5px;
`;
export const BatchText = styled.div`
    color: #101010;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    width: ${(props) => props.width};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
export const ParkedLabel = styled.label`
    font-size: 10px;
    border: 1px solid #008d00;
    padding: 2px;
    border-radius: 10px;
    background: #cbffd2;
    width: 50px;
    text-align: center;
    color: #008d00;
`;
export const AllocatedText = styled.label`
    color: #131313;
    font-size: 10px;
    font-family: 'AvenirNextWorld Regular';
`;
export const RedCircle = styled.div`
    height: 10px;
    width: 10px;
    background-color: #ed002a;
    border-radius: 5px;
    margin-right: 2px;
    color: #ffffff;
    font-size: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3.5px;
`;
export const PhysicianAndAccount = styled.div`
    display: flex;
    flex-direction: column;
    margin: 5px 0 0 0;
`;

export const Account = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-width: 0;
`;

export const AccountName = styled.p`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    max-width: ${({ truncate }) => (truncate ? '62%' : 'unset')};
`;

export const AccountId = styled.div`
    display: flex;
    flex-shrink: 0;
    font-family: 'AvenirNextWorld Italic';
    font-size: 14px;
    margin: 0 0 0 5px;
`;

export const Physician = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-width: 0;
`;

export const PhysicianName = styled.p`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    max-width: ${({ truncate }) => (truncate ? '62%' : 'unset')};
`;

export const PhysicianId = styled.div`
    display: flex;
    flex-shrink: 0;
    font-family: 'AvenirNextWorld Italic';
    font-size: 14px;
    margin: 0 0 0 5px;
`;

export const Parked = styled.div`
    color: #008d00;
    font-family: 'AvenirNextWorld Demi';
    font-size: 10px;
    border: 0.5px solid #00610099;
    background: #cbffd2;
    width: 20%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 17px;
    height: 18px;
`;
export const AddedCartButton = styled.div`
    width: ${({ width }) => (width ? width : '30px')};
    height: ${({ height }) => (height ? height : '30px')};
    visibility: ${({ visibility }) => visibility};
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ mbBackGroundColor }) =>
        mbBackGroundColor ? mbBackGroundColor : 'transparent'};
    /* box-shadow: ${({ boxShadow }) =>
        boxShadow ?  '0px 0px 6px #00000029' : 'none'}; */
    border-radius: 6px;
    opacity: 1;

    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
`;
export const AddCartIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: ${({ width }) => (width ? width : '14px')};
    height: ${({ height }) => (height ? height : '14px')};
    cursor: pointer;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    border-shadow:none
`;

export const MoreItemView = styled.div`
    margin: 2.25px 0px 0px 8px;
    color: #1010eb;
    font-size: 11px;
    font-family: 'AvenirNextWorld Regular';
    cursor: pointer;
`;

export const Flex = styled.div`
    display: flex;
    // margin-top: 20px;
    height: ${({ height }) => (height ? height : '')};
    ${media.mobileDevice`
        margin-top:0px;
    `}
`;

export const PriceContainer = styled.div`
    display: flex;
    margin-bottom: 10px;
    ${media.mobileDevice`
    
    `}
`;

export const ExtPrice = styled.div`
    margin-left: 190px;
    ${media.mobileDevice`
    margin-left: 183px;
    `}
`;

export const UnitPrice = styled.div`
    margin-left: -160px;
    ${media.mobileDevice`

    `}
`;

export const SubItemCount = styled.div`
    margin-left: 50px;
    ${media.mobileDevice`

    `}
`;

export const PriceLabel = styled.label`
    color: #000000;
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    ${media.mobileDevice`     

    `}
`;

export const Price = styled.div`
    font-size: 14px;
    text-align: center;
    margin: -5px 2px;
    color: #000000;
    opacity: 1;
    height: 29px;
    width: 37px;
    ${media.mobileDevice`     
 
    `}
`;

export const DiscountPrice = styled(Price)`
    margin: auto 2px;
    color: #e5047e;
    text-decoration: line-through;
    -webkit-text-decoration-line: line-through;
    text-decoration-line: line-through;
`;
export const NonTissue = styled.div`
    margin-top: 10px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '70px')};

    ${media.mobileDevice`
        
    `}
`;

export const Tissue = styled.div`
    margin-top: ${(props) =>
        props.variant === 'productSearch' ? '0px' : '10px'};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '70px')};

    ${media.mobileDevice`
    
    `}
`;

export const TissueText = styled.div`
    font-family: 'AvenirNextWorld Bold';
    float: right;
    font-size: 10px;
    letter-spacing: -0.1px;
    color: ${({ color }) => (color ? color : '#0F9BBF')};
    //height: 17px;
    width: 24px;
    text-align: center;
    ${media.mobileDevice`     
    letter-spacing: 0px;
    opacity: 0.99;
    `}
`;

export const TissueUnitPrice = styled.input.attrs({
    type: 'text',
    placeholder: setCurrencyFormat(0),
})`
    font-family: 'AvenirNextWorld Demi';
    border: 2px solid #ececec;
    font-size: 13px;
    text-align: center;
    border-radius: 4px;
    color: #000000;
    opacity: 1;
    height: 29px;
    width: 50px;
    margin-bottom: 10px;
    ::placeholder,
    ::-webkit-input-placeholder {
        color: #a0a8a8;
    }
    ${media.mobileDevice`     
     
     `}
`;
export const DiscountLabel = styled.div`
    margin-top: 4px;
    color: #e5047e;
    font-size: 12px;
    font-family: 'AvenirNextWorld Demi';
`;

export const BundleItemCart = styled.div`
    color: ${(props) => (props.color ? props.color : '#130e4a')};
    font-family: 'AvenirNextWorld Demi';
    font-size: ${(props) =>
        props.fontSizeDesktop ? props.fontSizeDesktop : '18px'};
    cursor: ${(props) => (props.clickable ? 'pointer' : '')};
    ${media.mobileDevice`     
        font-size: ${(props) =>
            props.fontSizeMobile ? props.fontSizeMobile : '18px'};
    `}
    letter-spacing: ${(props) =>
        props.setNameLetterSpacing ? props.setNameLetterSpacing : 'normal'};
    line-height: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '20px' : 'unset'};
    white-space: ${(props) =>
        props.enableTemplateCardSpecificStyling ? ' break-spaces' : 'unset'};
    display: flex;
    align-content: center;
`;

export const ImageIcon = styled.div`
    display: flex;
    margin-top: 23px;
    margin-left: -6rem;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
    display: flex;
    margin-left: -2.2rem;
    align-items: center;
    margin-bottom: 4rem;
    margin-top: 1.5rem;
    padding-bottom: 20px;
    `}
    ${media.mobileDevice`    
    display: flex;
    margin-left: -2.2rem;
    align-items: center;
    margin-bottom: 4rem;
    margin-top: 1.5rem;
    padding-bottom: 20px;
    `}
`;

export const StatusTextBundle = styled.div`
    font-family: 'AvenirNextWorld bold';
    float: right;
    font-size: 10px;
    letter-spacing: -0.1px;
    color: #654adc;
    //height: 17px;
    width: 50px;
    text-align: center;
    font-weight: bold;
    border-radius: 3px;
    ${media.mobileDevice`     
     
    `}
`;

export const StatusBundle = styled.div`
    display: flex;
    justify-content: center;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '')};
    height: 21px;
    width: 59px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '35px')};
    background: #f2efff 0% 0% no-repeat padding-box;
    border-radius: 4px;

    opacity: 1;
    align-items: center;
    text-align: center;
    ${media.mobileDevice`
        border-radius: 4px;
    `}
`;

export const TagContainer = styled.div`
    display: flex;
    width: 100%;
    margin-top: -7px;
`;

export const AccountTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 18px;
    color: #140f4b;
    display: flex;
    justify-content: space-between;
    letter-spacing: 0px;
    opacity: 1;
    text-align: left;
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '0px')};
    margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '0px')};
    background: ${(props) =>
        props.backgroundColor ? props.backgroundColor : ''};
    padding: 10px 10px 10px 13px ${media.mediumDevice`
        
    `} ${media.smalDevice`
        
    `} ${media.mobileDevice`    
     font-size:${(props) => (props.fontSize ? props.fontSize : '15px')};
     padding: ${(props) =>
        props.isFromConsignmentAdd ? '0px 10px 10px 18px' :
         props.isUSUser && props.isEquityTemplate
             ? '10px 10px 10px 13px'
             : '10px 10px 10px 15px'};
     width: ${({ width, widthSets}) => (width? width: widthSets ? '100%' :'')};

    `};
`;
export const HeaderContainer = styled.div`
    display: flex;
    width: 100%;
    background-color: ${({ mbBackGroundColor }) =>
        mbBackGroundColor ? mbBackGroundColor : 'transparent'};
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    //  background: #f5f5f5 0% 0% no-repeat padding-box;
    background: #ebebeb 0% 0% no-repeat padding-box;
    margin-top: 20px;
    padding: 6px 0;
    /* padding-top: 10px;
    padding-bottom: 25px; */
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '5px')};
    width: ${({ width }) => (width ? width : '100%')};
    height: ${({ height }) => (height ? height : '22px')};
    text-align: left;
    //font:15px Avenir Next World;
    letter-spacing: 0px;
    text-transform: uppercase;
    opacity: 1;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '15px'};
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #5f5f5f;

    ${media.mobileDevice`
        margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '0')};
        margin-bottom: ${({ mbMarginBottom }) =>
            mbMarginBottom ? mbMarginBottom : '0'};
        /* padding-bottom: 30px; */
        padding: ${({ mobilePadding }) =>
            mobilePadding ? mobilePadding : '0'};
        // extra space removed b/w tissue service label and shipping details
        // grey color applied from edge to edge
        height: ${({ mbHeight }) => mbHeight};
        
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        margin-left:${({ marginLeft }) => marginLeft && marginLeft};
        padding-left: ${({ mbPaddingLeft }) =>
            mbPaddingLeft ? mbPaddingLeft : '5px'};
        display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'flex')};
        align-items: center ;
        background-color: ${({ mbBackGroundColor }) =>
            mbBackGroundColor ? mbBackGroundColor : 'transparent'};
    `};
`;
export const BatchConatiner = styled.div`
    width: 96%;
    margin:  ${({ margin }) => (margin ? margin : ' 6px 0px 0px 9px')};
    height: ${({ height }) => height && height};
    margin-bottom: ${({ mbBottom }) => (mbBottom ? mbBottom : '0px')};
`;
export const BackgroundTag = styled.div`
    background: white;
    padding-top: 5px;
`;

export const SetsAndItemsValues = styled.div`
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    color: #000000;
    margin-left: ${({ isEquityTemp, marginLeft }) =>
        isEquityTemp ? '7px' : marginLeft ? marginLeft : '0px'};
    opacity: 1;
    word-break: break-word;
    text-transform: lowercase;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    // 10-20mm coming on same line
    width: ${({ width }) => (width ? width : '')};
    min-width: ${({ minWidth }) => (minWidth ? minWidth : '280px')};
    margin-top: ${({ isEquity, marginTop }) =>
        isEquity ? '-4px' : marginTop ? marginTop : '6px'};
    ${media.mobileDevice`  
        font-family: 'AvenirNextWorld Regular';  
        font-size:'13px'
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '')};
        height: ${({ mbHeight }) => (mbHeight ? mbHeight : '')};
    `}
    @media only screen and (min-width: 375px) and (max-width: 376px) {
        width: 100%;
        min-width: 100%;
    }
`;
export const CartActionItems = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: #140f4b;
    opacity: 1;
    display: flex;
    flex-direction: row;
    height: ${({ height }) => (height ? height : '20px')};
    width: ${({ width }) => (width ? width : '20%')};
    font-size: 13px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '20px')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    cursor: ${({ setCursor }) => (setCursor ? setCursor : null)};
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 20px;
    width : 200px,
    margin-right: ${({ marginRight }) =>
        marginRight ? marginRight : null};       
    white-space: nowrap;
    margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '0px')};
    `}
`;

export const CartHeaderTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    color: ${({ color }) => (color ? color : '#030330')};
    height: 36px;
    width: ${({ width }) => (width ? width : '82px')};
    font-size: 20px;
    // font-weight: 600;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-bottom: 6px;
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size:20px;
     width: 300px;
      //margin-top: -19px;
       // padding-left: 15px;
        margin-top: -11px;
        margin-left: 10px;
    `}
`;

export const CartHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    // width: 1120px;
    // height: 36px;
    margin-top: 20px;
    // margin-bottom: 12px;
    ${media.mobileDevice`     
     margin-top: 0px;
    // margin-bottom: 18px;
     background: #ffffff 0% 0% no-repeat padding-box;
     box-shadow: 0px 0px 6px #00000029;
    `}
`;

export const WaringMessage = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
`;

export const Text = styled.div`
    display: flex;
    justify-content: space-between;
    padding: ${({ padding }) => (padding ? padding : '10px')};
    align-items: center;
    color: ${({ color }) => (color ? color : '#4F4F4F')};
    position: relative;
    background: ${({ background }) =>
        background ? background : '#ffffff 0% 0% no-repeat padding-box'};
    ${(props) =>
        props.isBundlesChildren &&
        props.isExpanded &&
        `
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 15px;
          right: 15px;
          height: 1px;
          background-color: lightgray;
          display: block;
        }
    `}
`;

export const BundlePriceDiv = styled.div`
    background-color: ${({ background }) => background || 'white'};
    padding: 10px 21px;
    border-bottom: 1px solid lightgray;
`;

export const Title = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 18px;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
    color: ${({ color }) => (color ? color : '#140f4b')};
    display: flex;
    justify-content: space-between;
    letter-spacing: 0px;
    opacity: 1;
    text-align: left;
`;

export const Title2 = styled.div`
    font-size: 14px;
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '')};
    color: ${({ color }) => (color ? color : '#030330')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    display: contents;
`;

export const Title3 = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: ${({ minHeight }) =>
        minHeight ? minHeight : '3em'};
    font-size : 14px;
    color:#4C4C6C;
`;

export const CheckMarkImg = styled.img`
    width: 30px;
    height: 30px;
    object-fit: contain;
`;

export const InputBox = styled.input`
    text-align: center;
    &:focus {
        outline: none;
    }
    color: #000000;
    width: 48px;
    height: 38px;
    margin-top: -6px;
    margin-right: 5px;
    color: #000000;
    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;
